import apiClient from "./apiClient";
import {
  SiteParametersResponse,
  SiteParametersRequest,
} from "./Models/SiteParametersModel";
import { AxiosResponse } from "axios";

export const getSiteParameters = async (
  securityToken: string | null
): Promise<SiteParametersResponse> => {
  const requestData: SiteParametersRequest = {
    SecurityToken: securityToken,
  };

  try {
    const response: AxiosResponse<SiteParametersResponse> = await apiClient({
      method: "post",
      url: "/Parameters/GetDmsSiteParameters",
      data: requestData,
    });
    localStorage.setItem("SiteParameters", JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.error("GetSiteParameters Error:", error);
    throw error;
  }
};
